import * as React from 'react'
import { Select as ASelect } from 'antd'
import { FormattedMessage } from 'react-intl'
import { isObject } from 'formik'
import fieldProps from './fieldProps'

const isIrisResource = value => isObject(value) && value['@id']

const _renderOption = items =>
  items.map(item => (
    <ASelect.Option key={item.value || item.id} value={item.value || item.id} item={item}>
      {item.label || <FormattedMessage id={item.labelKey} />}
    </ASelect.Option>
  ))

@fieldProps
export default class Select extends React.Component {
  render() {
    const {
      value,
      valueKey = '@id',
      onChange,
      children,
      items,
      allowClear = true,
      disabled,
      empty,
      mode,
      style,
      placeholder,
      filterOption,
      filterSort,
      showSearch,
      className
    } = this.props

    // supporto valore iris
    let currentValue = value
    if (value && isIrisResource(currentValue)) {
      currentValue = currentValue[valueKey]
    }

    return (
      <ASelect
        allowClear={allowClear}
        mode={mode}
        className={className}
        disabled={disabled}
        value={currentValue}
        placeholder={placeholder}
        style={style}
        onChange={onChange}
        filterOption={filterOption}
        filterSort={filterSort}
        showSearch={showSearch}
      >
        {empty && <ASelect.Option value="" />}
        {items && _renderOption(items)}
        {children}
      </ASelect>
    )
  }
}
